module.exports = __webpack_public_path__ + "static/Refinance_edited-a11830e3e2bfc500abed4b6b7d3abbc8.jpg";